/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddToCartDto } from '../models/add-to-cart-dto';
import { ApplyVoucherDto } from '../models/apply-voucher-dto';
import { ApproximateDto } from '../models/approximate-dto';
import { ApproximateResponseDto } from '../models/approximate-response-dto';
import { SendToClientDto } from '../models/send-to-client-dto';
import { ShoppingCartDto } from '../models/shopping-cart-dto';

@Injectable({
  providedIn: 'root',
})
export class CartService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation shoppingCartControllerAddToCart
   */
  static readonly ShoppingCartControllerAddToCartPath = '/api/cart';

  /**
   * Add a calculation to cart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerAddToCart()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerAddToCart$Response(
    params: {
      body: AddToCartDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ShoppingCartDto>> {
    const rb = new RequestBuilder(this.rootUrl, CartService.ShoppingCartControllerAddToCartPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ShoppingCartDto>;
        }),
      );
  }

  /**
   * Add a calculation to cart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerAddToCart$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerAddToCart(
    params: {
      body: AddToCartDto;
    },
    context?: HttpContext,
  ): Observable<ShoppingCartDto> {
    return this.shoppingCartControllerAddToCart$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShoppingCartDto>) => r.body as ShoppingCartDto),
    );
  }

  /**
   * Path part for operation shoppingCartControllerRemoveFromCart
   */
  static readonly ShoppingCartControllerRemoveFromCartPath = '/api/cart/{id}/{calculationId}';

  /**
   * Remove calculation from cart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerRemoveFromCart()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerRemoveFromCart$Response(
    params: {
      id: string;
      calculationId: string;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ShoppingCartDto>> {
    const rb = new RequestBuilder(this.rootUrl, CartService.ShoppingCartControllerRemoveFromCartPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('calculationId', params.calculationId, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ShoppingCartDto>;
        }),
      );
  }

  /**
   * Remove calculation from cart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerRemoveFromCart$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerRemoveFromCart(
    params: {
      id: string;
      calculationId: string;
    },
    context?: HttpContext,
  ): Observable<ShoppingCartDto> {
    return this.shoppingCartControllerRemoveFromCart$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShoppingCartDto>) => r.body as ShoppingCartDto),
    );
  }

  /**
   * Path part for operation shoppingCartControllerGetCart
   */
  static readonly ShoppingCartControllerGetCartPath = '/api/cart/{id}';

  /**
   * Get a shopping cart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerGetCart()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerGetCart$Response(
    params: {
      id: string;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ShoppingCartDto>> {
    const rb = new RequestBuilder(this.rootUrl, CartService.ShoppingCartControllerGetCartPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ShoppingCartDto>;
        }),
      );
  }

  /**
   * Get a shopping cart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerGetCart$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerGetCart(
    params: {
      id: string;
    },
    context?: HttpContext,
  ): Observable<ShoppingCartDto> {
    return this.shoppingCartControllerGetCart$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShoppingCartDto>) => r.body as ShoppingCartDto),
    );
  }

  /**
   * Path part for operation shoppingCartControllerClone
   */
  static readonly ShoppingCartControllerClonePath = '/api/cart/{id}/clone';

  /**
   * Clone a shopping cart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerClone()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerClone$Response(
    params: {
      id: string;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ShoppingCartDto>> {
    const rb = new RequestBuilder(this.rootUrl, CartService.ShoppingCartControllerClonePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ShoppingCartDto>;
        }),
      );
  }

  /**
   * Clone a shopping cart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerClone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerClone(
    params: {
      id: string;
    },
    context?: HttpContext,
  ): Observable<ShoppingCartDto> {
    return this.shoppingCartControllerClone$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShoppingCartDto>) => r.body as ShoppingCartDto),
    );
  }

  /**
   * Path part for operation shoppingCartControllerApplyVoucher
   */
  static readonly ShoppingCartControllerApplyVoucherPath = '/api/cart/{id}/apply-voucher';

  /**
   * Apply voucher to cart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerApplyVoucher()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerApplyVoucher$Response(
    params: {
      id: string;
      body: ApplyVoucherDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ShoppingCartDto>> {
    const rb = new RequestBuilder(this.rootUrl, CartService.ShoppingCartControllerApplyVoucherPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ShoppingCartDto>;
        }),
      );
  }

  /**
   * Apply voucher to cart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerApplyVoucher$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerApplyVoucher(
    params: {
      id: string;
      body: ApplyVoucherDto;
    },
    context?: HttpContext,
  ): Observable<ShoppingCartDto> {
    return this.shoppingCartControllerApplyVoucher$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShoppingCartDto>) => r.body as ShoppingCartDto),
    );
  }

  /**
   * Path part for operation shoppingCartControllerRemoveVoucher
   */
  static readonly ShoppingCartControllerRemoveVoucherPath = '/api/cart/{id}/voucher';

  /**
   * Remove voucher from cart.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerRemoveVoucher()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerRemoveVoucher$Response(
    params: {
      id: string;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ShoppingCartDto>> {
    const rb = new RequestBuilder(this.rootUrl, CartService.ShoppingCartControllerRemoveVoucherPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ShoppingCartDto>;
        }),
      );
  }

  /**
   * Remove voucher from cart.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerRemoveVoucher$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  shoppingCartControllerRemoveVoucher(
    params: {
      id: string;
    },
    context?: HttpContext,
  ): Observable<ShoppingCartDto> {
    return this.shoppingCartControllerRemoveVoucher$Response(params, context).pipe(
      map((r: StrictHttpResponse<ShoppingCartDto>) => r.body as ShoppingCartDto),
    );
  }

  /**
   * Path part for operation shoppingCartControllerSaveToEmail
   */
  static readonly ShoppingCartControllerSaveToEmailPath = '/api/cart/{id}/save';

  /**
   * Send cart summary via email.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerSaveToEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerSaveToEmail$Response(
    params: {
      id: string;
      body: SendToClientDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, CartService.ShoppingCartControllerSaveToEmailPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'text',
          accept: '*/*',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
        }),
      );
  }

  /**
   * Send cart summary via email.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerSaveToEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerSaveToEmail(
    params: {
      id: string;
      body: SendToClientDto;
    },
    context?: HttpContext,
  ): Observable<void> {
    return this.shoppingCartControllerSaveToEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void),
    );
  }

  /**
   * Path part for operation shoppingCartControllerApproximate
   */
  static readonly ShoppingCartControllerApproximatePath = '/api/cart/approximate';

  /**
   * Approximate price.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `shoppingCartControllerApproximate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerApproximate$Response(
    params: {
      body: ApproximateDto;
    },
    context?: HttpContext,
  ): Observable<StrictHttpResponse<ApproximateResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, CartService.ShoppingCartControllerApproximatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ApproximateResponseDto>;
        }),
      );
  }

  /**
   * Approximate price.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `shoppingCartControllerApproximate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  shoppingCartControllerApproximate(
    params: {
      body: ApproximateDto;
    },
    context?: HttpContext,
  ): Observable<ApproximateResponseDto> {
    return this.shoppingCartControllerApproximate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApproximateResponseDto>) => r.body as ApproximateResponseDto),
    );
  }
}
